export type FrontendAppDeployment = 'piano' | 'draw' | 'guitar' | 'sing';

const DRAW_APP_VALUES: Record<string, true> = { draw: true, 'simply-draw': true, simply_draw: true };
const GUITAR_APP_VALUES: Record<string, true> = { guitar: true, 'simply-guitar': true, simply_guitar: true };

const normalizeDeploymentValue = (value?: string): string => (value || '').trim().toLowerCase();

export const getFrontendAppDeployment = (): FrontendAppDeployment => {
  const configuredApp = normalizeDeploymentValue(
    process.env.REACT_APP_APP_NAME || process.env.REACT_APP_FRONTEND_APP || process.env.REACT_APP_APP_DEPLOYMENT
  );
  if (DRAW_APP_VALUES[configuredApp]) return 'draw';
  if (GUITAR_APP_VALUES[configuredApp]) return 'guitar';
  if (['sing', 'simply-sing', 'simply_sing'].includes(configuredApp)) return 'sing';
  return 'piano';
};

export const isDrawFrontendDeployment = (): boolean => getFrontendAppDeployment() === 'draw';
export const isGuitarFrontendDeployment = (): boolean => getFrontendAppDeployment() === 'guitar';
